import React from "react";
import { Box, Container, SimpleGrid, Heading, Text, Icon, useColorModeValue } from "@chakra-ui/react";
import { FaShieldAlt, FaDesktop, FaLock } from "react-icons/fa";
import { TiltCard } from "../../common/TiltCard";
import { usePublicGlassSurface } from "../../common/publicVisual";

const ITEMS = [
  {
    icon: FaDesktop,
    title: "One workspace",
    text: "Screen AI, Media AI, Portfolio AI, Project AI, Todos AI, Daily Chore AI, notes, calendar, and splits—one sidebar.",
  },
  {
    icon: FaShieldAlt,
    title: "Free core app",
    text: "No monthly fee for the dashboard. AI Usage Credits are optional top-ups for capture AI and voice on AI tabs.",
  },
  {
    icon: FaLock,
    title: "Your data",
    text: "We use standard protections in transit and at rest. See Privacy Policy for details.",
  },
];

export default function TrustBand() {
  const glass = usePublicGlassSurface();
  const topLine = useColorModeValue(
    "rgba(45, 212, 191, 0.15)",
    "rgba(94, 234, 212, 0.1)"
  );
  const muted = useColorModeValue("gray.600", "gray.400");
  const iconClr = useColorModeValue("teal.600", "teal.300");

  return (
    <Box
      as="section"
      py={{ base: 10, md: 14 }}
      bg="transparent"
      borderTopWidth="1px"
      borderColor={topLine}
    >
      <Container maxW="container.xl" px={{ base: 4, md: 6 }}>
        <Heading as="h2" size="md" fontWeight="bold" textAlign="center" mb={10}>
          Why Manage360
        </Heading>
        <SimpleGrid columns={{ base: 1, md: 3 }} spacing={8}>
          {ITEMS.map((item) => (
            <TiltCard
              key={item.title}
              tilt={6}
              textAlign={{ base: "left", md: "center" }}
              borderWidth="1px"
              borderRadius="2xl"
              p={{ base: 6, md: 7 }}
              sx={{ transformStyle: "preserve-3d" }}
              {...glass}
            >
              <Icon
                as={item.icon}
                w={8}
                h={8}
                color={iconClr}
                mb={3}
                mx={{ base: 0, md: "auto" }}
                sx={{ transform: "translateZ(14px)" }}
              />
              <Text fontWeight="semibold" fontSize="md" mb={2}>
                {item.title}
              </Text>
              <Text fontSize="sm" color={muted} lineHeight="tall">
                {item.text}
              </Text>
            </TiltCard>
          ))}
        </SimpleGrid>
      </Container>
    </Box>
  );
}
